import React, { FC } from 'react';
import styled from 'styled-components';
import Colours from '../../../design-system/colours';

const ZERO_COUNT = '0';

const OvRecordCount: FC<{ value?: string }> = ({ value }) =>
  value === ZERO_COUNT ? <ZeroCount>{value}</ZeroCount> : <>{value ?? '-'}</>;

export default OvRecordCount;

const ZeroCount = styled.span`
  color: ${Colours.OV_RED};
`;
